























































































































import { defineComponent, ref } from '@vue/composition-api'
import { useGetters } from '@u3u/vue-hooks'
import gsap from 'gsap'
import { motionOK } from '@/inc/utils/motionOK'
import SecurityReportForm from '@/components/SecurityReportForm.vue'
import LineSplitter from '@/components/animation/LineSplitter.vue'
import Strech from '@/components/animation/Strech.vue'

export default defineComponent({
  name: 'security-report',
  components: {
    SecurityReportForm,
    LineSplitter,
    Strech,
  },
  setup() {
    const { content } = useGetters(['content'])

    const introTitleRef = ref()
    const introSubtitleRef = ref()
    const introAnimateIn = () => {
      if (motionOK()) {
        const TL = gsap.timeline({
          defaults: {
            duration: 1,
            ease: 'power4.out',
          },
        })

        if (introTitleRef.value) {
          TL.add(introTitleRef.value.getTween(), 'start')
        }
        if (introSubtitleRef.value) {
          TL.add(introSubtitleRef.value.getTween(), 'start+=0.25')
        }
      }
    }

    const titleRef = ref()
    const baselineRef = ref()
    const introContentRef = ref()
    const formSectionAnimateIn = () => {
      if (motionOK()) {
        const stagger = 0.075
        let index = 0

        const TL = gsap.timeline({
          defaults: {
            duration: 1,
            ease: 'power4.out',
          },
        })

        if (introContentRef.value) {
          TL.add(introContentRef.value.getTween(), 'start')
        }

        if (titleRef.value) {
          index += 1
          TL.add(titleRef.value.getTween(), `start+=${index * stagger}`)
        }

        if (baselineRef.value) {
          index += 1
          TL.add(baselineRef.value.getTween(), `start+=${index * stagger}`)
        }
      }
    }

    return {
      content,
      introTitleRef,
      introSubtitleRef,
      introAnimateIn,
      titleRef,
      baselineRef,
      introContentRef,
      formSectionAnimateIn,
    }
  },
})
